export const COLOR ={
    primary:'#E4174B'
}